var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5958_18",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36,
    height: 36
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5958_18)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 25.5H19.5V16.5H16.5V25.5ZM18 13.5C18.425 13.5 18.7813 13.3563 19.0688 13.0688C19.3563 12.7813 19.5 12.425 19.5 12C19.5 11.575 19.3563 11.2187 19.0688 10.9312C18.7813 10.6437 18.425 10.5 18 10.5C17.575 10.5 17.2188 10.6437 16.9313 10.9312C16.6438 11.2187 16.5 11.575 16.5 12C16.5 12.425 16.6438 12.7813 16.9313 13.0688C17.2188 13.3563 17.575 13.5 18 13.5ZM18 33C15.925 33 13.975 32.6062 12.15 31.8187C10.325 31.0312 8.7375 29.9625 7.3875 28.6125C6.0375 27.2625 4.96875 25.675 4.18125 23.85C3.39375 22.025 3 20.075 3 18C3 15.925 3.39375 13.975 4.18125 12.15C4.96875 10.325 6.0375 8.7375 7.3875 7.3875C8.7375 6.0375 10.325 4.96875 12.15 4.18125C13.975 3.39375 15.925 3 18 3C20.075 3 22.025 3.39375 23.85 4.18125C25.675 4.96875 27.2625 6.0375 28.6125 7.3875C29.9625 8.7375 31.0312 10.325 31.8187 12.15C32.6062 13.975 33 15.925 33 18C33 20.075 32.6062 22.025 31.8187 23.85C31.0312 25.675 29.9625 27.2625 28.6125 28.6125C27.2625 29.9625 25.675 31.0312 23.85 31.8187C22.025 32.6062 20.075 33 18 33ZM18 30C21.35 30 24.1875 28.8375 26.5125 26.5125C28.8375 24.1875 30 21.35 30 18C30 14.65 28.8375 11.8125 26.5125 9.4875C24.1875 7.1625 21.35 6 18 6C14.65 6 11.8125 7.1625 9.4875 9.4875C7.1625 11.8125 6 14.65 6 18C6 21.35 7.1625 24.1875 9.4875 26.5125C11.8125 28.8375 14.65 30 18 30Z",
    fill: "#1A73AA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.70517a8add6589dc9f33e6e1b3a7e384.svg";
export { ForwardRef as ReactComponent };